import React, { useState } from 'react'
import HighlightsImage from './HighlightsImage';
import HighlightsContent from './HighlightsContent';

const parseHighlights = (highlightsArray) => {
	if (Array.isArray(highlightsArray)) return highlightsArray;
	if (!highlightsArray) return [];

	try {
		const highlights = JSON.parse(highlightsArray);
		return Array.isArray(highlights) ? highlights : [];
	} catch {
		return [];
	}
}

const Highlights = (props) => {
	const { title, largeFont, highlightsArray = '[]' } = props;
	const [selectedItemIndex, setSelectedItemIndex] = useState(0);

	const data = parseHighlights(highlightsArray);
	const isLargeFont = largeFont === true || largeFont === 'true';
	const selectedItemImage = data[selectedItemIndex]?.image ?? null;
	
	const handleHover = (i) => {
		setSelectedItemIndex(i);
	}

	return (
		<div className="highlights__wrapper">
			<HighlightsImage image={selectedItemImage} />
			<HighlightsContent title={title} items={data} largeFont={isLargeFont} handleHover={handleHover} selectedItemIndex={selectedItemIndex} />
		</div>
	)
}

export default Highlights
